const content = `
<p class="ql-align-justify">
  &nbsp;
</p>
<p class="ql-align-justify">
  注册用户可以通过包小鉴平台出售二手闲置物，前提是该等闲置物符合包小鉴平台鉴别及质检。如您不同意该协议，应停止在包小鉴平台进行出售二手闲置物的操作。
</p>
<p class="ql-align-justify">
  &nbsp;
</p>
<p class="ql-align-justify">
  1.用户承诺对物品的合法性、真实性负全部法律责任，保证所提供的闲置物符合《中华人民共和国产品质量法》、《中华人民共和国消费者权益保护法》及其他法律、法规、部门规章和国家强制性标准的规定，并承诺按照法律法规及本规则和条款的约定对闲置物承担一切法律责任及法律后果。
</p>
<p class="ql-align-justify">
  &nbsp;
</p>
<p class="ql-align-justify">
  2.根据包小鉴的要求，用户应如实完整地披露拟售卖闲置物的品牌、型号(货号或版型等)、款式、购买来源、日期及价格、发票或收据、使用年限、既往保养情况、闲置物的现状、品相、成色、是否隐有瑕疵等任何对闲置物销售具有影响的信息。用户应保证闲置物信息的真实性及准确性，且应与用户所作声明完全一致，不得有闲置物描述与实际不符的发布行为，否则包小鉴将有权利取消其闲置物的售卖权，或视情况采取其他合适的措施。
</p>
<p class="ql-align-justify">
  &nbsp;
</p>
<p class="ql-align-justify">
  3.用户承诺拥有其售卖物品的个人所有权，且保证提供给包小鉴的二手闲置物为正规渠道物品，不得向包小鉴提供赃物、走私物、来历不明物及抵押物，或者是有赃物、走私物品嫌疑的物品。否则，包小鉴有权拒绝接收并且不承担任何责任。若物品的来源或权属、物品上的权利出现疑义，而给包小鉴造成的一切损失(包括但不限于包小鉴为维护其合法权益或因第三方向包小鉴主张权利而支付相应费用，如赔偿费、律师费、取证费、鉴别费、诉讼或仲裁费等)及由此产生的一切法律责任，均由用户承担。
</p>
<p class="ql-align-justify">
  &nbsp;
</p>
<p class="ql-align-justify">
  4.如因用户未能真实且完整的披露前述信息或违反上述保证及本条其他保证而给包小鉴造成的一切损失(包括但不限于包小鉴为维护其合法权益或因第三方向包小鉴主张权利而支付相应费用，如赔偿费、律师费、取证费、鉴别费、诉讼或仲裁费等)及由此产生的一切法律责任，均由用户承担。
</p>
<p class="ql-align-justify">
  &nbsp;
</p>
<p class="ql-align-justify">
  5.用户不得通过包小鉴售卖假冒伪劣、涉嫌侵权、来源非法等违法违规的闲置物。经查处核实或第三方权威机构书面证明闲置物为假冒伪劣、涉嫌侵权、来源非法等违法违规物品的情况下，包小鉴有权自行与相关部门联系处理，并将处理结果告知用户。用户需承担闲置物因前述情况而引起的全部不利法律后果，并应赔偿包小鉴因此而遭受的一切损失，赔偿金额为本规则和条款项下闲置物最终由包小鉴售出时成交价格(或包小鉴从用户购买该交易物品所支付的价格，以较高者为准)的10倍，且用户必须以公开信或其他令包小鉴满意的形式向包小鉴赔礼道歉。在前述金额不足弥补包小鉴因此而遭受的损失的情况下，用户应进一步赔偿直至包小鉴全部损失得到赔偿为止。
</p>
<p class="ql-align-justify">
  &nbsp;
</p>
<p class="ql-align-justify">
  6.通过在线款式审核的闲置物，可享受顺丰到付服务寄给包小鉴。选择保价、个性化包装等增值服务产生的费用用户自理。若未经过在线款式审核直接寄至包小鉴，则运费需由用户自理。
</p>
<p class="ql-align-justify">
  &nbsp;
</p>
<p class="ql-align-justify">
  7.用户不得在发货时，故意调换闲置商品或偷换零件。
</p>
<p class="ql-align-justify">
  &nbsp;
</p>
<p class="ql-align-justify">
  8.由包小鉴签收前，该等物品的风险由用户自行承担。包小鉴有权拒绝接收用户提供的不符合售卖标准、信息不符或未按照规定流程提供的闲置物并根据本规则和条款的约定退回用户。
</p>
<p class="ql-align-justify">
  &nbsp;
</p>
<p class="ql-align-justify">
  9.用户选择在包小鉴运营平台售卖闲置物，必需接受包小鉴对每一件商品进行专业的鉴别。包小鉴致力于不断优化服务质量，但不排除由包小鉴运营平台购买的闲置物，在复检中鉴别为做工粗糙、成色不符、时尚度低、货值低等。在任何情况下，由于将您的闲置物不符合包小鉴的接受标准对您或第三方带来的任何损失，包小鉴无需承担任何责任。
</p>
<p class="ql-align-justify">
  &nbsp;
</p>
<p class="ql-align-justify">
  10.包小鉴将在签收后的一定期限内根据本规则和条款对闲置物进行鉴别和报价。用户在收到包小鉴通过短信、邮件或站内通知形式的报价通知后，即可登录包小鉴运营平台查看鉴别情况和报价。
</p>
<p class="ql-align-justify">
  &nbsp;
</p>
<p class="ql-align-justify">
  11.&nbsp;寄卖是指用户在包小鉴运营平台上寄卖其通过包小鉴鉴别的闲置物，包小鉴将提供清洁、拍照、包装物流及所有售后服务并向用户收取佣金。
</p>
<p class="ql-align-justify">
  &nbsp;
</p>
<p class="ql-align-justify">
  12.&nbsp;寄卖商品的寄卖服务期间（以下简称“寄卖期”）是从物品自上架之日到商品售出。在此期间用户可以选择申请商品退回，若用户申请退回，则应支付包小鉴50元/件专业服务费，并同意包小鉴选择顺丰到付，用户自行承担退回运费。
</p>
<p class="ql-align-justify">
  &nbsp;
</p>
<p class="ql-align-justify">
  13.在买家拍下物品后一经付款，无法再调价。一旦寄卖的物品通过包小鉴运营平台售出，包小鉴将免佣金，商品销售费用48小时内支付至用户包小鉴账户。
</p>
<p class="ql-align-justify">
  &nbsp;
</p>
<p class="ql-align-justify">
  13.&nbsp;为避免闲置物遗失，在闲置物上架前包小鉴运营平台无法支持退回操作。如需退回闲置物，请在闲置物上架后联系客服申请退回。若用户在寄卖期内申请退回闲置物，则应支付包小鉴50元/件专业服务费(鉴别护理费)，并同意包小鉴选择到付，用户自行承担退回运费。
</p>
<p class="ql-align-justify">
  &nbsp;
</p>
<p class="ql-align-justify">
  14.&nbsp;您知晓并同意，包小鉴在宣传运营时，会将您的寄卖商品借用来拍摄专题宣传照片或视频。拍摄过程中会有包小鉴专职负责人员全程参与，以确保该商品被正常方法使用和保管，使用后及时收回，并重新清洁、消毒、护理后上架。使用您寄卖的商品拍摄宣传照，也可以提升商品的曝光率，有助于商品售出率。您同意在接受包小鉴寄卖服务的同时，自动授权包小鉴有权利根据宣传需要，使用您在包小鉴寄卖的商品。如果包小鉴在借用过程中对商品造成损伤，包小鉴将按照商品定价赔偿。
</p>
<p class="ql-align-justify">
  &nbsp;
</p>
<p class="ql-align-justify">
  15.&nbsp;包小鉴有权根据其鉴别结果拒绝用户的闲置物，包括但不限于无法验证为正品、严重变形、磨损、破损或有明显补色痕迹、成色或款式风格与包小鉴用户匹配度低、不在包小鉴接受品牌库中的物品等。未通过鉴别的闲置物，包小鉴会就处理方式与您联系。如果无法联系到您或在您收到此类通知7天之内没有回复，默认您放弃闲置物的所有权，交由包小鉴处理。在任何情况下，由于放弃闲置物所有权，对您或第三方带来的任何损失，包小鉴无需承担任何责任。
</p>
<p class="ql-align-justify">
  &nbsp;
</p>
<p class="ql-align-justify">
  16.包小鉴将按用户确认的退回地址，寄付寄回未通过鉴别的闲置物，如果送货服务人员送达时您不在已确认的退回地址等待收货，送货服务人员将会通过电子订单表格中注明的电话号码与您联系以另行约定一个新的送货日期和时间。第二次送货日期必须是在原送货日期之后的3天内。假如您第二次送货时仍不在场，商品将被装运回包小鉴，且由此产生的退回运费需要由您来承担。如果您仍然希望签收商品，请与包小鉴客服取得联系。在包小鉴因前述事由收到退回的闲置物后，包小鉴会就退回快递与您联系。如果无法联系到您或您在收到此类通知7天之内没有回复，默认用户放弃闲置物的所有权，交由包小鉴处理。在任何情况下，由于退件对您或第三方带来的任何损失，包小鉴无需承担任何责任。
</p>
<p class="ql-align-justify">
  &nbsp;
</p>
<p class="ql-align-justify">
  17.对于鉴别达标的商品，在上架前，包括在包小鉴给出报价前及包小鉴给出报价后，不允许退回，用户均不可以要求退回。
</p>
<p class="ql-align-justify">
  &nbsp;
</p>
<p class="ql-align-justify">
  18.如错寄给包小鉴，用户需补缴到付的运费后，包小鉴再通过到付退回，运费由用户自理。
</p>
<p class="ql-align-justify">
  &nbsp;
</p>
<p class="ql-align-justify">
  &nbsp;
</p>
<p class="ql-align-justify">
  19.免责声明：对于所有在包小鉴运营平台上获得的或通过包小鉴运营平台所能获得的商品、服务和信息内容，包小鉴运营平台不提供任何形式明确的或隐含的担保或保证，包括但不限于以上所述所有商品、服务和信息的可销性及对于特定目的、资格及不侵权范畴的遵守性。
</p>
<p class="ql-align-justify">
  包小鉴不保证包小鉴运营平台内的所有信息是准确、有效、可靠或可利用的，也不保证上述所有信息没有侵犯任何第三方的合法权益。由于不同的网络浏览器或不同的计算机显示屏观看时网页显示的差异，包小鉴的商品在图像和颜色方面可能与真实的物品不尽一致。因此，所有显示的图片、视频和其他商品显示方法仅限于图示目的，在任何情况下不得认为是合同的组成部分。假如供出售的商品与包小鉴运营平台上的描述明显不符的，您可以联系客服进行确认。经包小鉴确认确实属于错误情况或重大疏忽情况的，包小鉴运营平台将会尽合理努力更正。
</p>
<p class="ql-align-justify">
  包小鉴也不保证包小鉴运营平台的网址、服务器或包小鉴运营平台发送的电子邮件内没有病毒或破坏性插件。
</p>
<p class="ql-align-justify">
  包小鉴无需对您或他人的以下任何损失或损伤负责，无论是任何自然的、直接的、间接的、必然的、特别的、惩罚性的损失或其它由于包小鉴运营平台上销售的商品的故障或不正确使用造成的损伤和损害。
</p>
<p class="ql-align-justify">
  除了以上的陈述，无论何种原因包小鉴对您的购买行为的赔偿金额将不会超过您为此次购买行为已经支付或者应该支付给包小鉴的费用的总额。包小鉴也无需因为对商品描述上的偏差或忽略承担赔偿责任。
</p>
<p class="ql-align-justify">
  &nbsp;
</p>
<p class="ql-align-justify">
  &nbsp;
</p>
<p class="ql-align-justify">
  协议更新日期：2020年11月
</p>
<p>
  <br>
</p>
`
export default {
  content,
  title: '《包小鉴回收、寄卖协议》'
}
